module.exports = __webpack_public_path__ + "img/prediction_edit.69af5bd4.png";